import { render, staticRenderFns } from "./Setwire.vue?vue&type=template&id=5b8a6d9c&"
import script from "./Setwire.vue?vue&type=script&lang=js&"
export * from "./Setwire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports